var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4999 3.3335C20.1666 3.3335 3.83325 19.6668 3.83325 40.0002C3.83325 60.3335 20.1666 76.6668 40.4999 76.6668C60.8332 76.6668 77.1666 60.3335 77.1666 40.0002C77.1666 19.6668 60.8332 3.3335 40.4999 3.3335ZM40.4999 70.0002C23.8333 70.0002 10.4999 56.6668 10.4999 40.0002C10.4999 23.3335 23.8333 10.0002 40.4999 10.0002C57.1666 10.0002 70.4999 23.3335 70.4999 40.0002C70.4999 56.6668 57.1666 70.0002 40.4999 70.0002ZM53.8332 43.3335C55.8332 43.3335 57.1666 42.0002 57.1666 40.0002C57.1666 38.0002 55.8332 36.6668 53.8332 36.6668H27.1666C25.1666 36.6668 23.8333 38.0002 23.8333 40.0002C23.8333 42.0002 25.1666 43.3335 27.1666 43.3335H53.8332Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1014_9122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 75,
    height: 74
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4999 3.3335C20.1666 3.3335 3.83325 19.6668 3.83325 40.0002C3.83325 60.3335 20.1666 76.6668 40.4999 76.6668C60.8332 76.6668 77.1666 60.3335 77.1666 40.0002C77.1666 19.6668 60.8332 3.3335 40.4999 3.3335ZM40.4999 70.0002C23.8333 70.0002 10.4999 56.6668 10.4999 40.0002C10.4999 23.3335 23.8333 10.0002 40.4999 10.0002C57.1666 10.0002 70.4999 23.3335 70.4999 40.0002C70.4999 56.6668 57.1666 70.0002 40.4999 70.0002ZM53.8332 43.3335C55.8332 43.3335 57.1666 42.0002 57.1666 40.0002C57.1666 38.0002 55.8332 36.6668 53.8332 36.6668H27.1666C25.1666 36.6668 23.8333 38.0002 23.8333 40.0002C23.8333 42.0002 25.1666 43.3335 27.1666 43.3335H53.8332Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1014_9122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    fill: "#E7D65C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c1c1847324bcaa437270a06ab6f6e6d2.svg";
export { ForwardRef as ReactComponent };